import React , {useState} from "react"
import { Link } from "react-router-dom"
import { isAuthenticated } from "../auth/helper"
import Base from "../core/Base"
import {createCategory} from  "../admin/helper/adminapicall"

const AddCategory = () =>{

    const [name , setName] = useState("")
    const [error , setError] = useState(false)
    const [success , setSuccess] = useState(false)

    const {user , token} = isAuthenticated()
    
    const goBack = () => (
       <div className = "mt-5">
         <Link className = "btn btn-sm btn-warning mb-3" to = "/admin/dashboard">Back To Admin Home</Link>
       </div>    
    )

    const handlechange = event => {
       setError("")
       setName(event.target.value)

    }

    const onSubmit = event => {
       event.preventDefault()
       setError("")
       setSuccess(false)

       //backend requset fired
       createCategory(user._id , token , {name})
       .then(data => {
           if(data.error)
           {
               setError(true)
           }
           else
           {
               setError("")
               setSuccess(true)
               setName("")
           }
       })
    }

    const suucessMessage = () => {
       if(success)
       {
           return <h4 className = "text-success">Category Created SuccessFully!</h4>
       }
    }

    const warningMessage = () => {
        if(error)
        {
            return <h4 className = "text-success">Category Creation Failed!</h4>
        }
    }

    const myCategoryForm = () =>(
       <form>
         <div className = "form-group">
           <p className = "lead">Enter the Category</p>
           <input 
             type = "text" 
             className = "form-control my-3" 
             onChange = {handlechange}
             value = {name}
             autoFocus 
             required 
             placeholder = "For Example Summer">
            </input>
            <button onClick = {onSubmit} className = "btn btn-outline-info">Create Category</button>
         </div>
       </form>
    )

    return(
        <Base title = "Create a Category" decription = "Add a new Category for our Tshirt Store" className = "container bg-info p-4"> 
           <div className = "row bg-white rounded">
             <div className = "col-md-8 offset-md-2">
               {suucessMessage()}
               {warningMessage()}
               {myCategoryForm()}
               {goBack()}
             </div>
           </div>
        </Base>
    )
}

export default AddCategory